import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/berart.webp';
import screenshot_target from '../../../images/letterfunnel/berriepelser.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Berrie Pelser"
      firstname="Berrie"
      companyname="Ber|Art"
      competition="Savvii en Level Level"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/berriepelser.js